import type { AclosetShopPlatformTypeCode } from '@/MetadataType';

type PlatformConstant = {
  [key in
    | 'PLATFORM_CAFE24'
    | 'PLATFORM_NAVER_SMART_STORE'
    | 'PLATFORM_BUNJANG'
    | 'PLATFORM_PLAYAUTO'
    | 'PLATFORM_INSTAGRAM'
    | 'PLATFORM_ACLOSET'
    | 'PLATFORM_OKPOS']: AclosetShopPlatformTypeCode;
};

type ListType = PlatformConstant & {
  [key in string]: string;
};

/**
 * @deprecated 메타데이터 값으로 이동.
 */
export const constantList: ListType = {
  PLATFORM_CAFE24: 'SHOP_PLATFORM-TYPE_CAFE24',
  PLATFORM_NAVER_SMART_STORE: 'SHOP_PLATFORM-TYPE_NAVER-SMART-STORE',
  PLATFORM_BUNJANG: 'SHOP_PLATFORM-TYPE_BUNJANG',
  PLATFORM_INSTAGRAM: 'SHOP_PLATFORM-TYPE_INSTAGRAM',
  PLATFORM_PLAYAUTO: 'SHOP_PLATFORM-TYPE_PLAYAUTO',
  PLATFORM_ACLOSET: 'SHOP_PLATFORM-TYPE_ACLOSET',
  PLATFORM_OKPOS: 'SHOP_PLATFORM-TYPE_OKPOS',

  KEY_CAFE24: '카페24',
  KEY_NAVER_SMART_STORE: '네이버',
  KEY_BUNJANG: '번개장터',
  KEY_PLAYAUTO: '플레이오토',
  KEY_ACLOSET: '세컨솔드',
  KEY_INSTAGRAM: '인스타그램',
};

/**
 * @deprecated 메타데이터 값으로 이동.
 */
export const PLATFORM_CATEGORY_ORDERED_LIST = [
  constantList.PLATFORM_CAFE24,
  constantList.PLATFORM_NAVER_SMART_STORE,
  constantList.PLATFORM_BUNJANG,
  constantList.PLATFORM_PLAYAUTO,
  constantList.PLATFORM_INSTAGRAM,
];
